const parserLocalizationSettings = {
  thousandSeparator: ",",
  decimalSeparator: ".",
  locale: "en"
};
function charToRegexString(char) {
  if (char === ".")
    return "\\.";
  else
    return char;
}
export function removeLocalization(stringifiedExpression, localizationSettings) {
  return stringifiedExpression.replace(new RegExp(charToRegexString(localizationSettings.thousandSeparator), "g"), "").replace(new RegExp(charToRegexString(localizationSettings.decimalSeparator), "g"), parserLocalizationSettings.decimalSeparator);
}
export function addLocalization(stringifiedExpression, localizationSettings) {
  return stringifiedExpression.replace(new RegExp(charToRegexString(parserLocalizationSettings.decimalSeparator), "g"), localizationSettings.decimalSeparator);
}
